import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { isDefined } from '@fi-shared/utils';
import { Subject } from 'rxjs';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { ILightWeightUser } from '@fi-shared/models';

@Injectable()
export class UserSearchService {
    private Users: ILightWeightUser[] = [];
    private usersBuModuleType = [];

    private lastInitializeSettings = {};

    constructor(private fiBackend: FiBackendService) {}

    Initialize(applicationSettings?) {
        if (this.lastInitializeSettings != applicationSettings) {
            this.lastInitializeSettings = applicationSettings;

            if (!applicationSettings) {
                this.fiBackend.fetchData<any[]>('Core/User/GetUsersForSharing').then((users) => {
                    if (users) {
                        this.Users = users.slice();
                    }
                });
            }
        }
    }

    SearchUsers(
        searchText: string,
        moduleType,
        searchObjectId: number,
        takeUntil?: Subject<void>,
    ): IFiHttpPromise<ILightWeightUser[]> {
        function getCacheKey() {
            return moduleType + '&' + searchObjectId;
        }

        function filterUserFunc(user, searchText: string) {
            return user.FullName.toLowerCase().indexOf((searchText || '').trim().toLowerCase()) !== -1;
        }

        const promise = new Promise<ILightWeightUser[]>((resolve, reject) => {
            if (!moduleType) resolve(this.Users.filter((user) => filterUserFunc(user, searchText)));
            else if (isDefined(this.usersBuModuleType[getCacheKey()]))
                resolve(this.usersBuModuleType[getCacheKey()].filter((user) => filterUserFunc(user, searchText)));
            else {
                const promise = this.fiBackend.fetchData<any[]>(
                    `Core/User/GetUsersForSharing?id=0&moduleType=${moduleType}&searchObjectId=${searchObjectId ?? ''}`,
                );
                if (takeUntil) {
                    takeUntil.subscribe(() => promise.cancel());
                }
                promise.then((users) => {
                    this.usersBuModuleType[getCacheKey()] = [];

                    if (users) {
                        for (var i = 0; i < users.length; i++) {
                            this.usersBuModuleType[getCacheKey()].push(users[i]);
                        }
                    }

                    resolve(this.usersBuModuleType[getCacheKey()].filter((user) => filterUserFunc(user, searchText)));
                });
                promise.catch(() => {
                    resolve([]);
                });
            }
        });

        return promise;
    }
}
